// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "backend/v1/config.proto" (package "backend.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
/**
 * GET /api/config: public, non-secret runtime configuration for the client
 * (architecture-redesign.md section 4). Each backend returns its own environment's values.
 *
 * @generated from protobuf message backend.v1.ClientConfig
 */
export interface ClientConfig {
    /**
     * @generated from protobuf field: string app_env = 1;
     */
    appEnv: string; // development | staging | demo | production
    /**
     * @generated from protobuf field: backend.v1.ClientConfig.FirebaseConfig firebase = 2;
     */
    firebase?: ClientConfig_FirebaseConfig;
    /**
     * @generated from protobuf field: string auth_emulator_host = 3;
     */
    authEmulatorHost: string; // development only
    /**
     * @generated from protobuf field: bool show_dev_console = 4;
     */
    showDevConsole: boolean;
    /**
     * @generated from protobuf field: bool require_email_verification = 5;
     */
    requireEmailVerification: boolean;
    /**
     * @generated from protobuf field: string min_app_version = 6;
     */
    minAppVersion: string; // mobile installs older than this must update
    /**
     * @generated from protobuf field: string commit_sha = 7;
     */
    commitSha: string; // the backend's build
    /**
     * @generated from protobuf field: bool stripe_enabled = 8;
     */
    stripeEnabled: boolean;
    /**
     * @generated from protobuf field: bool flinks_enabled = 9;
     */
    flinksEnabled: boolean; // bank connections (POST /api/bank-link/*) are configured
}
/**
 * @generated from protobuf message backend.v1.ClientConfig.FirebaseConfig
 */
export interface ClientConfig_FirebaseConfig {
    /**
     * @generated from protobuf field: string api_key = 1;
     */
    apiKey: string; // a public identifier, not a secret
    /**
     * @generated from protobuf field: string auth_domain = 2;
     */
    authDomain: string;
    /**
     * @generated from protobuf field: string project_id = 3;
     */
    projectId: string;
    /**
     * @generated from protobuf field: string storage_bucket = 4;
     */
    storageBucket: string;
    /**
     * @generated from protobuf field: string messaging_sender_id = 5;
     */
    messagingSenderId: string;
    /**
     * @generated from protobuf field: string app_id = 6;
     */
    appId: string;
    /**
     * @generated from protobuf field: string measurement_id = 7;
     */
    measurementId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class ClientConfig$Type extends MessageType<ClientConfig> {
    constructor() {
        super("backend.v1.ClientConfig", [
            { no: 1, name: "app_env", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "firebase", kind: "message", T: () => ClientConfig_FirebaseConfig },
            { no: 3, name: "auth_emulator_host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "show_dev_console", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "require_email_verification", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "min_app_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "commit_sha", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "stripe_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "flinks_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ClientConfig
 */
export const ClientConfig = new ClientConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClientConfig_FirebaseConfig$Type extends MessageType<ClientConfig_FirebaseConfig> {
    constructor() {
        super("backend.v1.ClientConfig.FirebaseConfig", [
            { no: 1, name: "api_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "auth_domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "project_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "storage_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "messaging_sender_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "measurement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ClientConfig.FirebaseConfig
 */
export const ClientConfig_FirebaseConfig = new ClientConfig_FirebaseConfig$Type();
